import LocaleState from "state/LocaleState";

const localeState = new LocaleState();

export default localeState;
